var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.page.css, attrs: { id: _vm.page.id } },
    _vm._l(_vm.page.items, function (item, index) {
      return _c("sv-file-item", {
        key: index,
        attrs: { item: item, question: _vm.question },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }